import styled from '@emotion/styled'

import * as constants from 'view/styles/constants'

export const ValidationIssuesContainer = styled.ul`
  color: ${constants.ACCENT_BAD};
  list-style-type: none;
`
